export default "__VITE_ASSET__Dwiyh6zY__"